import React, { useState, useCallback } from 'react'
import firebase from 'firebase/app'
import { Trans, useTranslation } from 'react-i18next'
import {
  FormButton,
  FormHeader,
  FormRow,
  FormFieldset,
  FormLabel
} from '../../../../common/components/Form'
import Icon from '../../../../common/components/Icon'
import { LabelSpacer } from '../../../../common/components/Label/Label'
import Text, { Paragraph } from '../../../../common/components/Text'

export const usePasswordReset = email => {
  const [status, setStatus] = useState('initial')
  const resetPassword = useCallback(async () => {
    setStatus('sending')
    // await new Promise(resolve => setTimeout(resolve, 2000))
    await firebase
      .auth()
      .sendPasswordResetEmail(email)
      .catch(error => {
        setStatus('error')
        // if (error.code === 'auth/user-not-found')
      })

    setStatus('sent')
  }, [email])
  const clear = useCallback(() => setStatus('initial'))
  return [resetPassword, status, clear]
}

const ChangePassword = ({ email }) => {
  const [resetPassword, status, clear] = usePasswordReset(email)
  const { t } = useTranslation()
  return (
    <>
      <FormHeader>{t('settings.changePassword')}</FormHeader>
      <FormFieldset>
        {status === 'initial' ? (
          <FormButton type="button" onClick={resetPassword}>
            <Text>{t('settings.resetPassword.send')}</Text>
            <LabelSpacer />
            <Icon icon="arrow-right" />
          </FormButton>
        ) : status === 'sending' ? (
          <FormButton primary>
            <Text>{t('settings.resetPassword.sending')}</Text>
            <LabelSpacer />
            <Icon icon="loader-square" />
          </FormButton>
        ) : status === 'sent' ? (
          <FormRow>
            <div>
              <FormLabel grey align="left flex">
                <Text normal black truncate>
                  <Trans
                    i18nKey="settings.resetPassword.sent"
                    values={{ email }}
                  >
                    Sent to <strong>email</strong>
                  </Trans>
                </Text>
              </FormLabel>
            </div>
            <div>
              <FormButton onClick={clear}>
                <Text>{t('settings.resetPassword.clear')}</Text>
              </FormButton>
            </div>
          </FormRow>
        ) : (
          <FormButton diabled>
            <Text>{t('settings.resetPassword.error')}</Text>
            <LabelSpacer />
            <Icon icon="arrow-right" />
          </FormButton>
        )}
      </FormFieldset>

      <Paragraph grey small>
        <Trans i18nKey="settings.resetPassword.note" values={{ email }}>
          Will send link to <strong>email</strong> to reset
        </Trans>
      </Paragraph>
    </>
  )
}

export default ChangePassword
